import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AlertCircle, RefreshCw } from "lucide-react";

const ErrorState = ({ message = "Something went wrong", onRetry }) => {
  return (
    <div className="flex items-center justify-center h-96" data-testid="error-state">
      <Card className="bg-[#0f1419] border-red-500/30 p-8 max-w-md text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-500/10 rounded-full mb-4">
          <AlertCircle className="h-8 w-8 text-red-400" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2">Error</h3>
        <p className="text-gray-400 mb-6">{message}</p>
        {onRetry && (
          <Button
            onClick={onRetry}
            className="bg-[#3dd9c5] hover:bg-[#35c4b5] text-white"
            data-testid="retry-btn"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Try Again
          </Button>
        )}
      </Card>
    </div>
  );
};

export default ErrorState;
